import {Mapper} from '@s-ui/domain'

export default class FromVehicleInfoRawDataToVehicleInfoValueObjectMapper extends Mapper {
  constructor({
    fromImagesListRawDataToImagesListValueObjectMapper,
    fromVersionSpecificationsRawDataToVersionSpecificationsValueObjectMapper,
    fromSearchUrlParamToSearchCodeValueObjectMapper,
    descriptionItemValueObjectFactory,
    electricFeaturesMapper,
    equipmentValueObjectFactory,
    equipmentSectionValueObjectFactory,
    vehicleInfoValueObjectFactory,
    groupedVersionSpecificationsValueObjectFactory,
    versionSpecificationsValueObjectFactory
  }) {
    super()
    this._fromImagesListRawDataToImagesListValueObjectMapper = fromImagesListRawDataToImagesListValueObjectMapper
    this._fromVersionSpecificationsRawDataToVersionSpecificationsValueObjectMapper =
      fromVersionSpecificationsRawDataToVersionSpecificationsValueObjectMapper
    this._fromSearchUrlParamToSearchCodeValueObjectMapper = fromSearchUrlParamToSearchCodeValueObjectMapper
    this._descriptionItemValueObjectFactory = descriptionItemValueObjectFactory
    this._fromElectricFeaturesRawDataToElectricFeaturesVOMapper = electricFeaturesMapper
    this._equipmentValueObjectFactory = equipmentValueObjectFactory
    this._equipmentSectionValueObjectFactory = equipmentSectionValueObjectFactory
    this._vehicleInfoValueObjectFactory = vehicleInfoValueObjectFactory
    this._groupedVersionSpecificationsValueObjectFactory = groupedVersionSpecificationsValueObjectFactory
    this._versionSpecificationsValueObjectFactory = versionSpecificationsValueObjectFactory
    this._grouped = false
  }

  _parseDate = date => new Date(date).toLocaleDateString()

  setParams = ({grouped}) => {
    this._grouped = grouped

    return this
  }

  map = ({vehicleInfo, make, model, electricFeatures}) => {
    const {items: images} = this._fromImagesListRawDataToImagesListValueObjectMapper
      .map({
        images: vehicleInfo.images
      })
      .toJSON()

    const {
      groupedSpecifications: {
        body,
        consumption: {
          acceleration,
          averageConsumption: consumptionAverage,
          extraUrbanConsumption: consumptionExtraUrban,
          topSpeed,
          urbanConsumption: consumptionUrban
        } = {},
        cycle,
        engine,
        isCurrent: isMarketable,
        makeId: makeIdGrouped,
        modelId: modelIdGrouped,
        price: priceGrouped,
        version: versionGrouped,
        year: yearGrouped
      } = {},
      specifications: {doors} = {}
    } = vehicleInfo

    const mappedElectricFeatures = this._fromElectricFeaturesRawDataToElectricFeaturesVOMapper.map({
      electricFeatures
    })

    const groupedSpecifications = this._groupedVersionSpecificationsValueObjectFactory({
      body: this._versionSpecificationsValueObjectFactory({
        ...body,
        version: versionGrouped
      }),
      consumption: this._versionSpecificationsValueObjectFactory({
        acceleration,
        consumptionAverage,
        consumptionExtraUrban,
        consumptionUrban,
        topSpeed
      }),
      ...(cycle && {
        cycle: this._versionSpecificationsValueObjectFactory({
          ...cycle,
          ...(mappedElectricFeatures && {
            electricFeatures: mappedElectricFeatures
          })
        })
      }),
      ...(engine && {
        engine: this._versionSpecificationsValueObjectFactory({
          ...engine,
          ...(mappedElectricFeatures && {
            electricFeatures: mappedElectricFeatures
          })
        })
      })
    })

    const specifications = this._versionSpecificationsValueObjectFactory({
      ...vehicleInfo.specifications,
      ...(mappedElectricFeatures && {electricFeatures: mappedElectricFeatures}),
      doors: Number(doors)
    })

    const {
      initDate,
      year,
      makeId,
      price,
      equipment: {standard, optional}
    } = vehicleInfo

    const equipment = this._equipmentValueObjectFactory({
      standard: standard.map(({group: title, descriptions}) =>
        this._equipmentSectionValueObjectFactory({
          title,
          descriptions: descriptions.map(item => this._descriptionItemValueObjectFactory({value: item}))
        })
      ),
      optional: optional.map(({group: title, descriptions}) =>
        this._equipmentSectionValueObjectFactory({
          title,
          descriptions: descriptions.map(item => this._descriptionItemValueObjectFactory({value: item}))
        })
      )
    })

    const {searchCode: makeCode} = this._fromSearchUrlParamToSearchCodeValueObjectMapper
      .map({
        searchUrlParam: make
      })
      .toJSON()

    const {searchCode: modelCode} = this._fromSearchUrlParamToSearchCodeValueObjectMapper
      .map({
        searchUrlParam: model
      })
      .toJSON()

    const initMarketedDate = this._parseDate(initDate)

    return this._vehicleInfoValueObjectFactory({
      vehicleInfo: {
        equipment,
        ...(this._grouped && {groupedSpecifications}),
        images,
        ...(initDate && {initMarketedDate}),
        isMarketable,
        make: makeCode,
        makeId: makeId || makeIdGrouped,
        model: modelCode,
        modelId: modelIdGrouped,
        price: price || priceGrouped,
        ...(!this._grouped && {specifications}),
        year: year || yearGrouped
      }
    })
  }
}
